import { axiosWithConfig } from "@assembly/config/axios"

export const getSkills = (payload: any) => {
    return axiosWithConfig.post(`/contractor/dashboard/skills/search`, payload, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    })
}